module.exports = __webpack_public_path__ + "img/51ne.ccf762c9.svg";